module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.$parent.isAdminPage(_vm.$route.path)) ? _c('aside', {
    staticClass: "aside-menu"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-toggle": "tab",
      "href": "#timeline",
      "role": "tab"
    }
  }, [_c('i', {
    staticClass: "icon-list"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#messages",
      "role": "tab"
    }
  }, [_c('i', {
    staticClass: "icon-speech"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#settings",
      "role": "tab"
    }
  }, [_c('i', {
    staticClass: "icon-settings"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "timeline",
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "callout m-0 py-h text-muted text-xs-center bg-faded text-uppercase"
  }, [_c('small', [_c('b', [_vm._v("Today")])])]), _vm._v(" "), _c('hr', {
    staticClass: "transparent mx-1 my-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "callout callout-warning m-0 py-1"
  }, [_c('div', {
    staticClass: "avatar float-xs-right"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/7.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("Meeting with\n                    "), _c('strong', [_vm._v("Lucas")])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted mr-1"
  }, [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v("  1 - 3pm")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "icon-location-pin"
  }), _vm._v("  Palo Alto, CA")])]), _vm._v(" "), _c('hr', {
    staticClass: "mx-1 my-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "callout callout-info m-0 py-1"
  }, [_c('div', {
    staticClass: "avatar float-xs-right"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/4.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("Skype with\n                    "), _c('strong', [_vm._v("Megan")])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted mr-1"
  }, [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v("  4 - 5pm")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "icon-social-skype"
  }), _vm._v("  On-line")])]), _vm._v(" "), _c('hr', {
    staticClass: "transparent mx-1 my-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "callout m-0 py-h text-muted text-xs-center bg-faded text-uppercase"
  }, [_c('small', [_c('b', [_vm._v("Tomorrow")])])]), _vm._v(" "), _c('hr', {
    staticClass: "transparent mx-1 my-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "callout callout-danger m-0 py-1"
  }, [_c('div', [_vm._v("New UI Project -\n                    "), _c('strong', [_vm._v("deadline")])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted mr-1"
  }, [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v("  10 - 11pm")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "icon-home"
  }), _vm._v("  creativeLabs HQ")]), _vm._v(" "), _c('div', {
    staticClass: "avatars-stack mt-h"
  }, [_c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/2.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/3.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/4.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/5.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/6.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })])])]), _vm._v(" "), _c('hr', {
    staticClass: "mx-1 my-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "callout callout-success m-0 py-1"
  }, [_c('div', [_c('strong', [_vm._v("#10 Startups.Garden")]), _vm._v("Meetup")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted mr-1"
  }, [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v("  1 - 3pm")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "icon-location-pin"
  }), _vm._v("  Palo Alto, CA")])]), _vm._v(" "), _c('hr', {
    staticClass: "mx-1 my-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "callout callout-primary m-0 py-1"
  }, [_c('div', [_c('strong', [_vm._v("Team meeting")])]), _vm._v(" "), _c('small', {
    staticClass: "text-muted mr-1"
  }, [_c('i', {
    staticClass: "icon-calendar"
  }), _vm._v("  4 - 6pm")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "icon-home"
  }), _vm._v("  creativeLabs HQ")]), _vm._v(" "), _c('div', {
    staticClass: "avatars-stack mt-h"
  }, [_c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/2.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/3.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/4.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/5.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/6.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/7.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "avatar avatar-xs"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/8.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  })])])]), _vm._v(" "), _c('hr', {
    staticClass: "mx-1 my-0"
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane p-1",
    attrs: {
      "id": "messages",
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "py-1 pb-3 mr-1 float-xs-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/7.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "avatar-status tag-success"
  })])]), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted float-xs-right mt-q"
  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
    staticClass: "text-truncate font-weight-bold"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "py-1 pb-3 mr-1 float-xs-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/7.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "avatar-status tag-success"
  })])]), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted float-xs-right mt-q"
  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
    staticClass: "text-truncate font-weight-bold"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "py-1 pb-3 mr-1 float-xs-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/7.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "avatar-status tag-success"
  })])]), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted float-xs-right mt-q"
  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
    staticClass: "text-truncate font-weight-bold"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "py-1 pb-3 mr-1 float-xs-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/7.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "avatar-status tag-success"
  })])]), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted float-xs-right mt-q"
  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
    staticClass: "text-truncate font-weight-bold"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_c('div', {
    staticClass: "py-1 pb-3 mr-1 float-xs-left"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "/static/img/avatars/7.jpg",
      "alt": "admin@bootstrapmaster.com"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "avatar-status tag-success"
  })])]), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted float-xs-right mt-q"
  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
    staticClass: "text-truncate font-weight-bold"
  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane p-1",
    attrs: {
      "id": "settings",
      "role": "tabpanel"
    }
  }, [_c('h6', [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "aside-options"
  }, [_c('div', {
    staticClass: "clearfix mt-2"
  }, [_c('small', [_c('b', [_vm._v("Option 1")])]), _vm._v(" "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-success switch-sm float-xs-right"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])]), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]), _vm._v(" "), _c('div', {
    staticClass: "aside-options"
  }, [_c('div', {
    staticClass: "clearfix mt-1"
  }, [_c('small', [_c('b', [_vm._v("Option 2")])]), _vm._v(" "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-success switch-sm float-xs-right"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])]), _vm._v(" "), _c('div', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]), _vm._v(" "), _c('div', {
    staticClass: "aside-options"
  }, [_c('div', {
    staticClass: "clearfix mt-1"
  }, [_c('small', [_c('b', [_vm._v("Option 3")])]), _vm._v(" "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-success switch-sm float-xs-right"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "aside-options"
  }, [_c('div', {
    staticClass: "clearfix mt-1"
  }, [_c('small', [_c('b', [_vm._v("Option 4")])]), _vm._v(" "), _c('label', {
    staticClass: "switch switch-text switch-pill switch-success switch-sm float-xs-right"
  }, [_c('input', {
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("System Utilization")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase mb-q mt-2"
  }, [_c('small', [_c('b', [_vm._v("CPU Usage")])])]), _vm._v(" "), _c('progress', {
    staticClass: "progress progress-xs progress-info m-0",
    attrs: {
      "value": "25",
      "max": "100"
    }
  }, [_vm._v("25%")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("348 Processes. 1/4 Cores.")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase mb-q mt-h"
  }, [_c('small', [_c('b', [_vm._v("Memory Usage")])])]), _vm._v(" "), _c('progress', {
    staticClass: "progress progress-xs progress-warning m-0",
    attrs: {
      "value": "70",
      "max": "100"
    }
  }, [_vm._v("70%")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("11444GB/16384MB")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase mb-q mt-h"
  }, [_c('small', [_c('b', [_vm._v("SSD 1 Usage")])])]), _vm._v(" "), _c('progress', {
    staticClass: "progress progress-xs progress-danger m-0",
    attrs: {
      "value": "95",
      "max": "100"
    }
  }, [_vm._v("95%")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("243GB/256GB")]), _vm._v(" "), _c('div', {
    staticClass: "text-uppercase mb-q mt-h"
  }, [_c('small', [_c('b', [_vm._v("SSD 2 Usage")])])]), _vm._v(" "), _c('progress', {
    staticClass: "progress progress-xs progress-success m-0",
    attrs: {
      "value": "10",
      "max": "100"
    }
  }, [_vm._v("10%")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("25GB/256GB")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ccc0782!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Aside.vue
// module id = 568
// module chunks = 97